import SecondaryIconButton from "@mostrans/web-components/components/advanced/Button/SecondaryIconButton";
import Button from "@mostrans/web-components/components/base/Button";
import { Loading } from "@mostrans/web-components/components/base/Loading";
import { Icon, Paper } from "@mui/material";
import React, {
  Suspense,
  lazy,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import "react-alice-carousel/lib/scss/alice-carousel.scss";
import { useHistory } from "react-router-dom";
// import Swiper, { A11y, Autoplay, Navigation, Pagination } from "swiper";
import { A11y, Autoplay, Navigation, Pagination } from 'swiper';
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useGetFeaturedJobs } from "../../../GQL/Opportunity/hooks/useGetFeaturedJobs";
import { useGetMasterTestimoniForPublic } from "../../../GQL/Testimonial/useGetMasterTestimoniForPublic";
import { bgVideo, gallery, highlight } from "../../../assets";
import CardCarousel from "../../../components/Card/Home/CardCarousel";
import CardCeo from "../../../components/Card/Home/CardCeo";
import FilterInputSearchCustom from "../../../components/Filter/FilterInputSearchCustom";
import Testimonial from "../../../components/General/Testimonial";
import Footer from "../../../components/Home/Footer";
import Navbar from "../../../components/Home/Navbar";
import SocialPanel from "../../../components/Home/SocialPanel";
import TabCompany from "../../../components/Home/TabCompany";
import NativeSelectMasterDivisi from "../../../components/Select/NativeSelectMasterDivisi";
import NativeSelectMasterLevel from "../../../components/Select/NativeSelectMasterLevel";
import { useGlobalFilter } from "../../../shared/hooks/useGlobalFilter";
import FeaturedJobs from "./FeaturedJobs";
import "./Home.css";
import ButtonCarousel from "./components/ButtonCarousel";
import { DETAIL_ARRAY } from "../../../shared/constants";
const ImageGallery = lazy(() =>
  import("../../../components/Home/ImageGallery")
);
const CardDemography = lazy(() =>
  import("../../../components/Card/Home/CardDemography")
);

function Home() {
  const [dataTestimoni] = useGetMasterTestimoniForPublic();
  const { orderedJobs } = useGetFeaturedJobs();
  const navigate = useHistory();

  const { filter, setFilter } = useGlobalFilter();
  const [searchInput, setSearchInput] = useState();

  const handleInput = () => {
    setFilter({ search: searchInput });
    navigate.push({
      state: { search: searchInput },
      pathname: "/explorejobs",
    });
  };

  const [indexes, setIndexes] = useState({
    previousIndex: 0,
    currentIndex: 0,
    nextIndex: 1,
  });

  const handleCardTransition = useCallback(() => {
    if (indexes.currentIndex >= DETAIL_ARRAY.length - 1) {
      setIndexes({
        previousIndex: DETAIL_ARRAY.length - 1,
        currentIndex: 0,
        nextIndex: 1,
      });
    } else {
      setIndexes((prevState) => ({
        previousIndex: prevState.currentIndex,
        currentIndex: prevState.currentIndex + 1,
        nextIndex:
          prevState.currentIndex + 2 === DETAIL_ARRAY.length
            ? 0
            : prevState.currentIndex + 2,
      }));
    }
  }, [indexes.currentIndex]);

  useEffect(() => {
    const transitionInterval = setInterval(() => {
      handleCardTransition();
    }, 5000);

    return () => clearInterval(transitionInterval);
  }, [handleCardTransition, indexes]);

  const suspensify = useCallback((component) => {
    const defaultFallback = <Loading />;
    return <Suspense fallback={defaultFallback}> {component} </Suspense>;
  }, []);

  const videoRef = useRef();

  useEffect(() => {
    if (videoRef) videoRef.current.play();
  }, []);

  const [isExpanded, setExpanded] = useState(false);

  const togglePanel = () => {
    setExpanded(!isExpanded);
  };


  return (
    <React.Fragment>
      <SocialPanel isExpanded={isExpanded} togglePanel={togglePanel} />
      <Navbar />
      <div className="w-full">
        <section className="container-section">
          <div className="landing-hero">
            <div className="landing-hero__vid">
              <video autoPlay muted loop className="bg-video" ref={videoRef}>
                <source
                  src={bgVideo}
                  // src="https://ik.imagekit.io/mostrans/MOSTRANSCAREERmp4?updatedAt=1698820385122"
                  type="video/mp4"
                />
              </video>
            </div>
            <div className="landing-hero__content">
              <div className="w-full md:w-2/3">
                <div className="landing-hero__content__heading">
                  <h1 className="text-white text-center">
                    Langkah Besar Bersama <br />
                    <span className="text-primary-main">Mostrans</span>
                  </h1>
                  <h3 className="text-primary-main text-center">
                    #LifeAtMostrans
                  </h3>
                </div>
              </div>
            </div>
            <div className="search-bar-container gap-2 pl-2 pr-2 p-1 text-center align-items-center">
              <div className="search-container d-flex flex-column flex-grow-1">
                <FilterInputSearchCustom
                  resetOnMount
                  resetOnUnmount
                  searchInput={searchInput}
                  setSearchInput={setSearchInput}
                  placeholder="type in the job you are looking for"
                />
                <div className="border-bottom-1 border-outlineSoft mt-1"></div>
                <div className="filter-select d-flex gap-1 mt-1">
                  <NativeSelectMasterDivisi resetOnMount />
                  <NativeSelectMasterLevel resetOnMount />
                </div>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <Button
                  // onClick={() => navigate.push("/explorejobs")}
                  onClick={handleInput}
                  variant="contained"
                  sx={{
                    ":hover": {
                      boxShadow: "7px 7px rgb(0,0,0)",
                    },
                  }}>
                  Search Job
                </Button>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white-home">
          <div className="container d-flex flex-column justify-content-center align-items-center pt-4 pb-4">
            <h4 className="text-primary-main pb-1">
              Mengapa Harus Berkarir di
            </h4>
            <Paper
              className="d-flex align-items-start pt-50 pl-1 pr-1 mb-3"
              sx={{
                backgroundColor: "#0A8C4A",
                borderRadius: "10px",
                boxShadow: "10px 10px rgba(0, 0, 0)",
              }}>
              <img src={highlight} alt="highlight" />
              <h1 className="text-white" style={{ fontSize: "40px" }}>
                Mostrans
              </h1>
            </Paper>
            <p className="text-center" style={{ fontSize: "16px" }}>
              MOSTRANS adalah <i>Digital Platform</i> Transportasi Produk
              Farmasi dan Kesehatan Pertama di Indonesia yang menghubungkan{" "}
              <i>Shipper & Transporter</i> secara <i>real-time</i>. Kontribusimu
              sebagai <i>M-Titans (Mostrans Titans)</i> sangat berdampak pada
              keberlangsungan transportasi produk farmasi dan kesehatan untuk
              Indonesia yang lebih sehat.
            </p>
          </div>
          <div className="container pb-4">{suspensify(<TabCompany />)}</div>
          <Paper
            className="bg-paper"
            sx={{
              backgroundColor: "#C8F9CE",
              borderRadius: "40px 40px 0 0",
              boxShadow: "0 0",
            }}>
            <div className="container pt-4 pb-4">
              <div className="img-glr d-flex flex-column justify-content-center align-items-center">
                <h4 className="text-center text-primary-main pb-1">
                  Kenali Kami Lebih Dekat
                </h4>
                <Paper
                  className="pl-1 pr-1 mb-3"
                  sx={{
                    backgroundColor: "#0A8C4A",
                    borderRadius: "10px",
                    boxShadow: "10px 10px rgba(0, 0, 0)",
                  }}>
                  <h1
                    className="text-white text-center"
                    style={{ fontSize: "40px" }}>
                    M-TITANS
                  </h1>
                </Paper>
                <p
                  className="text-center text-primary-main"
                  style={{ fontSize: "16px" }}>
                  <i>Titans</i> menggambarkan sosok yang kuat dan tangguh dalam
                  menghadapi segala situasi. Dengan semangat <i>Titans</i>,
                  insan Mostrans bertekad untuk melampaui batas-batas diri,
                  tumbuh dan berkembang menjadi individu yang kokoh, penuh
                  kepercayaan diri, dan siap menghadapi tantangan yang akan
                  datang.
                </p>

                <div className="container d-flex justify-content-center align-items-center pt-4 pb-4">
                  {suspensify(<CardCeo />)}
                </div>
              </div>
            </div>
            <div className="demo-text container pb-1">
              <Paper
                className="pl-1 pr-1 mb-2"
                sx={{
                  backgroundColor: "#0A8C4A",
                  borderRadius: "10px",
                  boxShadow: "10px 10px rgba(0, 0, 0)",
                }}>
                <h1 className="text-dt text-white text-center">
                  Demografi M-TITANS
                </h1>
              </Paper>
            </div>
            <div className="container pb-5">
              <div className="card-demography">
                {suspensify(<CardDemography />)}
              </div>
            </div>
            <div className="pb-5">
              <img
                src={gallery}
                // src="https://ik.imagekit.io/mostrans/Div.Gallery%20(3).png?updatedAt=1700453578192"
                // src="https://ik.imagekit.io/mostrans/img%20gallery.png?updatedAt=1699432127109"
                alt="M-TITANS"
                style={{ width: "-webkit-fill-available" }}
              />
            </div>

            <Paper
              sx={{
                backgroundColor: "#0A8C4A",
                borderRadius: "40px 40px 0 0",
                boxShadow: "0 0",
              }}>
              <div className="carousel-bg">
                <div className="container pt-4 pb-4">
                  <div className="carousel d-flex justify-content-evenly align-items-center gap-5">
                    <div>
                      <h1
                        className="text-white"
                        style={{
                          fontWeight: 500,
                          fontSize: "70px",
                          lineHeight: 1.4,
                          letterSpacing: 1,
                          textShadow: "6px 6px rgba(0, 0, 0)",
                        }}>
                        Core Values<br />
                        <span style={{ color: "#C8F9CE" }}>Kami</span>
                      </h1>
                      <p
                        className="mt-2"
                        style={{ color: "white", fontSize: "20px" }}>
                        Core values adalah prinsip-prinsip dasar yang membimbing
                        tindakan dan budaya perusahaan, seperti kejujuran,
                        inovasi, atau kepedulian lingkungan. Ini adalah
                        nilai-nilai yang dianut para M-TITANS.
                      </p>
                      {suspensify(
                        <div className="btn-container d-flex justify-content-start mt-3 gap-1">
                          {DETAIL_ARRAY.map((item, index) => (
                            <ButtonCarousel
                              key={item.id}
                              index={index}
                              detailArray={item}
                              isActive={indexes.currentIndex}
                              onClick={() => {
                                setIndexes((p) => ({
                                  previousIndex: p.currentIndex,
                                  currentIndex: index,
                                  nextIndex: index + 1,
                                }));
                              }}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                    {suspensify(
                      <CardCarousel
                        key={DETAIL_ARRAY[indexes.currentIndex].id}
                        detailArray={DETAIL_ARRAY}
                        isActive={indexes.currentIndex}
                        prevIndex={indexes.previousIndex}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Paper>
          </Paper>

          <div className="pb-2">
            <div className="container d-flex flex-column justify-content-center align-items-center mt-4 mb-3">
              <h2 className="text-primary-main text-center">
                Dengarlah cerita mereka yang menjadi satu dengan kami
              </h2>
              <p
                className="text-primary-main text-center"
                style={{ fontSize: "18px" }}>
                Kami menampilkan kesan mereka selama bekerja di Mostrans.
              </p>
            </div>
            <div className="p-1">
              {suspensify(
                <>
                  <Swiper
                    tabIndex={1}
                    slidesPerView={2}
                    spaceBetween={-40}
                    autoplay={{ delay: 2500, disableOnInteraction: false }}
                    breakpoints={{
                      100: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      // 768: {
                      //   slidesPerView: 1,
                      // },
                      900: {
                        slidesPerView: 2,
                      },
                    }}
                    className="mySwiper"
                    navigation={{
                      nextEl: ".swiper-custom-pagination-next",
                      prevEl: ".swiper-custom-pagination-prev",
                    }}
                    loop={true}
                    centeredSlides={true}
                    scrollbar={{ draggable: true }}
                    modules={[Autoplay, Pagination, Navigation, A11y]}>
                    {dataTestimoni.data?.map((tmn) =>
                      suspensify(
                        <SwiperSlide key={tmn?.id}>
                          <Testimonial
                            className="landing-testimonial__card"
                            name={tmn?.karyawan?.employee_name}
                            title={tmn?.karyawan?.jabatan?.position_name}
                            image={tmn?.url_image}
                            testimoni={tmn?.testimony}
                            idTestimoni={tmn?.id}
                          />
                        </SwiperSlide>
                      )
                    )}
                  </Swiper>
                  <div className="d-flex justify-content-center align-items-center gap-1 mt-3">
                    <SecondaryIconButton
                      className="swiper-custom-pagination-prev"
                      style={{
                        backgroundColor: "#fff",
                        boxShadow: "3px 3px rgb(0, 0, 0)",
                      }}>
                      <Icon>arrow_back</Icon>
                    </SecondaryIconButton>
                    <SecondaryIconButton
                      className="swiper-custom-pagination-next"
                      style={{
                        backgroundColor: "#fff",
                        boxShadow: "3px 3px rgb(0, 0, 0)",
                      }}>
                      <Icon>arrow_forward</Icon>
                    </SecondaryIconButton>
                  </div>
                </>
              )}
            </div>
          </div>
        </section>
        {orderedJobs.length && suspensify(<FeaturedJobs />)}
      </div>
      <Footer />
    </React.Fragment>
  );
}

export default Home;
